import { ExternalApiData } from "@common/data-models/service/external-api-data";
import { PublicationListRecord } from "../records/publication-list-record";
import { PublicationRecord } from "../records/publication-record";
import moment from 'moment-timezone';

export class ExternalApiDataPublicationList extends ExternalApiData {

    public record: any = {};
    constructor(
        public actionName: string,
        public database: string,
        public path: string,
        public guid: string,
        public userId: string,
        metaRec: PublicationListRecord,
        channelSections: { [id: string]: Array<PublicationRecord> }
    ) {
        super(actionName, database, path, guid, userId);
        this.record["Type"] = metaRec.type;
        this.record["Path"] = metaRec.path.fullPath; 
        this.record["Guid"] = metaRec.guid;
        this.record["Title"] = metaRec.title;
        this.record["PSTPublicationChannelGUID"] = metaRec.publicationChannelGUID; 
        this.record["PSTPublicationChannelName"] = metaRec.channelName;
        this.record["PSTPublicationListRevisionNumber"] = metaRec.revisionNumber;
        if (metaRec.publicationTime) {
            this.record["PSTPublicationListTime"] = metaRec.publicationTime.moment.utc().format();
        }
        const payloadSections: { [id: string]: Array<string> } = {};
        for (let section in channelSections) {
            payloadSections[section] = channelSections[section].map((item) => item.linkedRecord.guid);
        }
        this.record["PublicationSequenceCollection"] = payloadSections;
        if (metaRec.createdTime) {
            this.record["CreatedDateTime"] = metaRec.createdTime.moment.utc().format();
        }
        if (metaRec?.publishedBy?.length > 0) {
            this.record["PSTPublicationListPublishedBy"] = metaRec.publishedBy[0];
        }
 
        this.record["PSTPublicationEditionName"] = metaRec.editionName;

        this.timestamp = moment(new Date()).utc().format();
    }

}
